import { Accordion, cn } from "@au-schein-de/au-ui-library";
import type { ProductNoEdibleInfo } from "@dransay/api";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { ProductDetailsTitle } from "./product-details-title.component";

type ProductDetailsProducerProps = {
	producer: ProductNoEdibleInfo["producer"];
};

export const ProductDetailsProducer = forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement> & ProductDetailsProducerProps
>(({ className, producer }, ref) => {
	const { t } = useTranslation();

	return (
		<div ref={ref} className={cn(className)}>
			<Accordion.Trigger>
				<ProductDetailsTitle title={t("producer")} info={t("producer")} />
			</Accordion.Trigger>

			<Accordion.Content>
				{producer?.logo && (
					<img
						className="my-4"
						src={producer?.logo ?? undefined}
						alt={producer?.name ?? undefined}
					/>
				)}

				<p className="text-gray-500 text-body-sm">{producer?.description}</p>
			</Accordion.Content>
		</div>
	);
});
ProductDetailsProducer.displayName = "ProductDetailsProducer";
